<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_1_Sentieri_Patriarchi/01_1_Patriarchi-top.jpg">
<div class="content">
    <h1>Pollino</h1>
    <h3>Sui sentieri dei "Patriarchi"</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale del Pollino</a> > <a class="active">Sui sentieri dei "Patriarchi"</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Morano Calabro-Convento di Colloreto-Monte Pollino-Morano Calabro</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_1_Sentieri_Patriarchi/01_1_Patriarchi-top.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Per chi vuole godere della vista degli “eroici” pini loricati è possibile raggiungere in bici o in auto da Morano Calabro lungo 
            il Sentiero Italia (SI T01) la località Colloreto, si percorrono circa 7 km di strada carrabile fino a località Colloreto. 
            Qui occorre parcheggiare l’auto e iniziare il cammino verso i ruderi del Monastero agostiniano, 
            fondato nel 1546 dal Beato Bernardo da Rogliano, eremita che si ritirò in queste contrade per abbracciare la regola di Sant’Agostino. 
            Nel 1560 la Congregazione degli Eremitani di Colloreto fu ufficialmente riconosciuta dal Papa Pio IV e si dimostrò molto accorsata e attiva per almeno due secoli, 
            fino alla soppressione voluta dalle leggi murattiane che determinò il conseguente abbandono del monastero.
            <br>
            <br>
            Da qui inizia il cammino a piedi sul sentiero n. 901 che porta a Piano Gaudolino, sul confine calabro-lucano, a quota 1693 m, 
            un tratto in salita (detto la Scala dei Moranesi) segnato da sorgenti copiose e di particolare interesse naturalistico. 
            Percorsi circa 5 Km, si giunge al Piano Gaudolino un luogo particolarmente indicato per una meritata pausa e per rifocillarsi, 
            grazie alla presenza della fontana e di un bivacco. Da qui si può sia raggiungere la cima del Monte Pollino percorrendo il Sentiero CAI 920B, 
            oppure, costeggiando la base del Monte, tra boschi di faggi, si continua fino al Piano di Toscano. Usciti dalla faggeta si segue il sentiero n. 923, 
            fino a conquistare, dopo circa 3 Km di cammino, la vista dei “Guardiani del Parco”, 
            un nucleo di monumentali Pini Loricati abbarbicati sul bordo occidentale della Piana del Pollino. 
            Al ritorno, ripassando dal Gaudolino si ridiscende fino a Colloreto e da qui si riprende l’auto per fare ritorno a Morano Calabro.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> a piedi</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>elevata</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>38 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>1</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1862 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1862 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Morano Calabro</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Morano Calabro</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>
<div class="newsletter">
    <div class="row">
        <div class="col- col-xl-6">
            <h2>Rimani in contatto con noi <br />
                iscriviti alla nostra newsletter ></h2>
        </div>
        <div class="col- col-xl-6">
            <h3>Entra nella community di Zampino Viaggi!</h3>
            <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                novità su proposte, esperienze, eventi e qualche curiosità.</p>  
        </div>
    </div>
    <div class="row">
        <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
    </div>
</div>
